import script from "./FormCodigoDescuento.vue?vue&type=script&setup=true&lang=js"
export * from "./FormCodigoDescuento.vue?vue&type=script&setup=true&lang=js"

import "./FormCodigoDescuento.vue?vue&type=style&index=0&id=7ca8952f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ca8952f"]])

export default __exports__